import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router'

interface Props {
  isEdit: boolean
  onSubmit: () => Promise<void>
}
export const PierFormHeader = observer(({ isEdit, onSubmit }: Props) => {
  const navigate = useNavigate()
  const { t } = useTranslate()

  const action = isEdit ? t('editPier', 'Edit pier') : t('addNewPier', 'Add new pier')

  const breadCrumbs = [
    { label: t(PATHS.config.piers.title), route: PATHS.config.piers.url },
    { label: action },
  ]

  return (
    <Header
      title={action}
      breadcrumbs={breadCrumbs}
      position='relative'
      rightRenderOption={
        <>
          <Button
            variant='text'
            color='inherit'
            data-cy='cancel-pier-btn'
            onClick={() => navigate(PATHS.config.piers.url)}
          >
            {t('cancel', 'Cancel')}
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => onSubmit()}
            data-cy='pier-save-btn'
          >
            {t('submit', 'Submit')}
          </Button>
        </>
      }
    />
  )
})
